import * as React from 'react';
import { AppBar as MuiAppBar, Toolbar, Typography, Avatar, Divider } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { useAuth0 } from '@cmr/react-auth0';
import { CmrLogo } from './cmr-logo';
import { SearchBox } from './search-box';
var useStyles = function (color) {
    var _a = useTheme(), zIndex = _a.zIndex, spacing = _a.spacing;
    return makeStyles({
        appBar: {
            zIndex: zIndex.drawer + 1,
            backgroundColor: color
        },
        logo: {
            height: '30px'
        },
        grow: {
            flexGrow: 1
        },
        logoLink: {
            textDecoration: 'none',
            color: 'white',
            display: 'flex',
            alignItems: 'center'
        },
        logoText: {
            fontWeight: 100,
            marginLeft: spacing(),
            marginRight: spacing()
        },
        logoDivider: {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            marginLeft: spacing(),
            marginTop: spacing(0.5),
            marginBottom: spacing(0.5)
        },
        logoIcon: {
            color: 'rgba(255, 255, 255, 0.5)'
        }
    })();
};
export var AppBar = function (_a) {
    var appName = _a.appName, showSearchBox = _a.showSearchBox, onSearch = _a.onSearch, children = _a.children, color = _a.color;
    var classes = useStyles(color || '#333333');
    var user = useAuth0().user;
    return (React.createElement(MuiAppBar, { position: 'static', className: classes.appBar },
        React.createElement(Toolbar, { variant: 'dense' },
            React.createElement(NavLink, { to: '/', className: classes.logoLink },
                React.createElement(CmrLogo, { className: classes.logo }),
                ' ',
                React.createElement(Divider, { orientation: 'vertical', flexItem: true, className: classes.logoDivider }),
                React.createElement(Typography, { variant: 'h4', display: 'inline', className: classes.logoText }, appName)),
            React.createElement("div", { className: classes.grow }),
            children,
            showSearchBox && React.createElement(SearchBox, { onSearch: onSearch }),
            " \u00A0",
            React.createElement(Avatar, { src: user.picture }))));
};
//# sourceMappingURL=app-bar.js.map